import axios from 'axios'
import store from '@/store/index.js';

class HttpRequest {
    constructor(url = process.env.VUE_APP_API_URL) {
        this.axiosInstance = axios.create({
            baseURL: url,
            timeout: 60000,
            withCredentials: true,
        })

        this.axiosInstance.interceptors.request.use(async (config) => {
            const token = await store.dispatch('keycloak/getToken') || sessionStorage.getItem('token');
            if (token) return { ...config, headers: { 'Authorization': 'Bearer ' + token } };
            return config;
        }, (error) => {
            return Promise.reject(error)
        })

        this.axiosInstance.interceptors.response.use((response) => {
            return response
        }, (error) => {
            return Promise.reject(error)
        })
    }

    setHeader(header) {
        this.axiosInstance.defaults.headers.common[header.key] = header.value
    }

    get(url, data, config) {
        return this.axiosInstance.get(url, { params: data, ...config })
    }

    create(url, data, config) {
        return this.axiosInstance.post(url, data, config)
    }

    post(url, data, config) {
        return this.axiosInstance.post(url, data, config)
    }

    update(url, data, config) {
        return this.axiosInstance.put(url, data, config)
    }

    delete(url, param, data, config) {
        return this.axiosInstance.delete(url, { params: param, data: data, ...config })
    }
}

export default HttpRequest